export default __webpack_public_path__ + "static/media/element_21.a33c3372.webp";